import { MeRepository } from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

const _directiveDependencies = [];
const _controllerDependencies = ['$scope'];

class AccountDetailsController {

    constructor($scope) {

        const me = MeRepository.getMyUser();
        const dateAdded = new Date(me.attributes.date_added);
        $scope.yearAdded = dateAdded.getFullYear();
        $scope.brandName = CWCONFIG.partnerConfig.name;

        $scope.sendAccountMixpanel = (buttonLabel) => {

            Mixpanel.send('ConnectWeb Home Click', {
                Label: 'Your Account',
                'Button label': buttonLabel,
            });

        };

    }

}


class AccountDetailsDirective {

    constructor() {

        this.template = require('./account-details.html');
        this.restrict = 'EA';
        this.replace = true;


        _controllerDependencies.push($scope =>
            new AccountDetailsController($scope));
        this.controller = _controllerDependencies;
        this.controllerAs = 'accountDetailsCtrl';

    }

}

_directiveDependencies.push(() => new AccountDetailsDirective());


angular.module('directives')
    .directive('accountDetails', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/account-details/account-details.js